export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const STRIPE_PUBLISH_KEY = process.env.REACT_APP_API_URL_STRIPE_PUBLISH_KEY;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const PUBNUB_PUBLISH_KEY = process.env.REACT_APP_PUBNUB_PUBLISH_KEY;
export const PUBNUB_SUBSCRIBE_KEY = process.env.REACT_APP_PUBNUB_SUBSCRIBE_KEY;
